import { Spinner } from 'react-bootstrap'
import { KTCard } from '../../../_metronic/helpers'
import { GET_LIVE_AGENT_QUESTIONS, SAVE_ANSWER } from '../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import { useEffect, useState, useRef, useReducer } from 'react'
import { alert } from '../../../utils/helper'
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


const MySwal = withReactContent(Swal)

function reducer(state: any, action: any) {
  if (action.type === 'error') {
    return {
      ...state,
      error: action.payload,
    };
  }
  throw Error('Unknown action.');
}
const Questions = ({
  pincode,
  setPincode,
  index,
  setIndex,
  setIsVerified,
  details,
  customerName,
  onComplete,
  cardClassName = '',
  rulesSection,
  isFlagged,
  tpvId,
  leaveCall,
  dispositionMsg,
  setShowGoBack,
  setStartTpv,
  postionMsg
}: any) => {
  const [elapsedTime, setElapsedTime] = useState<number>(0)
  const [enrollmentPosition, setEnrollmentPosition] = useState<number>(0)
  const [qusIndex, setQusIndex] = useState(1)
  const [state, dispatch] = useReducer(reducer, { error: "" });
  const [isYes, setIsYES] = useState(false)
  const [isNO, setIsNo] = useState(false)
  const [answer, setAnswer] = useState('')
  const countRef = useRef<any>(null)
  const handleTimerStart = () => {
    const startTimes = Date.now() - elapsedTime
    countRef.current = setInterval(() => {
      setElapsedTime(Date.now() - startTimes)
    }, 10)
  }
  const startTime = useRef<any>(0)
  const [getQuestion, { loading, data: question }] = useLazyQuery(GET_LIVE_AGENT_QUESTIONS, {
    onCompleted: () => (startTime.current = new Date()),
    onError: (err) => {
      dispatch({ type: 'error', payload: err.message });
      console.error('GraphQL Error:', err.message);
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: err.message,

      })
    },
    fetchPolicy: 'network-only',
  })
  const [saveAnswer] = useMutation(SAVE_ANSWER, {
    onCompleted: (data) => {
      if (!data.saveAnswerByPin.isCompleted) {
        setEnrollmentPosition(data.saveAnswerByPin.nextEnrollmentPosition)
        setIndex(data.saveAnswerByPin.nextQuestionIndex + 1)
        setQusIndex((pre) => pre + 1)
      } else {
        alert('Thank you for calling TPV solutions, Goodbye', 'success')
        setIsVerified(false)
        setIndex(0)
        Boolean(setPincode) && setPincode('')
        clearInterval(countRef.current)
        setElapsedTime(0)
        Boolean(onComplete) && onComplete()
      }
    },
    onError: (err) => {
      alert(err.message, 'error')
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (index !== 0) {
      setIsYES(false)
      setAnswer('')
      setIsNo(false)
      getQuestion({
        variables: {
          pincode: String(pincode),
          index: index - 1,
          enrollmentPosition

        },
      })
      if (index === 1) {
        handleTimerStart()
      }
    }
  }, [getQuestion, index, pincode, enrollmentPosition])
  const handleSubmit = () => {
    const answerInput = {
      questionId: question?.getLiveAgentQuestionsByPin?.questionId,
      questionDescription: question?.getLiveAgentQuestionsByPin?.questionDescription,
      questionType: question?.getLiveAgentQuestionsByPin?.questionType,
      recordingStartedAt: startTime.current,
      isLastQuestion: question?.getLiveAgentQuestionsByPin?.isLastQuestion,
    }

    if (question?.getLiveAgentQuestionsByPin?.questionType === 'SPEECH_ONLY') {
      saveAnswer({
        variables: {
          pincode,
          tpvId,
          answerInput: { ...answerInput, description: '', recordingEndAt: new Date(), enrollmentPosition, currentQuestionIndex: index - 1 },
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'VOICE_RESPONSE') {
      saveAnswer({
        variables: {
          pincode,
          tpvId,
          answerInput: { ...answerInput, description: answer, recordingEndAt: new Date(), enrollmentPosition, currentQuestionIndex: index - 1 },
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'YESNO') {
      saveAnswer({
        variables: {
          pincode,
          tpvId,
          answerInput: {
            ...answerInput,
            description: isYes ? 'yes.' : 'no.',
            recordingEndAt: new Date(),
            enrollmentPosition,
            currentQuestionIndex: index - 1
          },
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'DTMF') {
      saveAnswer({
        variables: {
          pincode,
          tpvId,
          answerInput: { ...answerInput, description: answer, recordingEndAt: new Date(), enrollmentPosition, currentQuestionIndex: index - 2 },
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') {
      if (isYes || isNO) {
        saveAnswer({
          variables: {
            pincode,
            tpvId,
            answerInput: {
              ...answerInput,
              description: isYes ? 'yes.' : 'no.',
              recordingEndAt: new Date(),
              enrollmentPosition,
              currentQuestionIndex: index - 1
            },
            isFlagged,
          },
        })
      } else {
        saveAnswer({
          variables: {
            pincode,
            tpvId,
            answerInput: { ...answerInput, description: answer, recordingEndAt: new Date(), enrollmentPosition, currentQuestionIndex: index - 1 },
            isFlagged,
          },
        })
      }
    }
  }
  const areYouSurePrompt = (
    title: string,
    onConfirm: () => void,
    onCancel: () => void,
    confirmText: string,
    cancelText: string,
    message: string
  ) => {
    MySwal.fire({
      title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      reverseButtons: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        onConfirm();
        try {
          const res = await leaveCall({
            variables: {
              tpvId,
              tpvStatus: 'Failed',
              disposition: Boolean(dispositionMsg) ? dispositionMsg : null,
            },
          });
        } catch (err) {
          console.error("leaveCall error:", err);
        }
        setIsVerified(false);
        setPincode('');
        alert('Thank you for calling TPV solutions, Goodbye', 'success');
      } else {
        onCancel();
      }
    });

  }
  return (
    <>
      <KTCard className='my-4 py-2 w-100 text-center'>
        <div className='flex-column justify-content-center  align-items-center border-0'>
          {Boolean(details?.clientName) && (
            <div className='card-title'>
              <h4 className='fs-3'>{customerName}</h4>
            </div>
          )}
          <h6 className='mb-0'>
            Call Time : {Math.floor(moment.duration(elapsedTime).asHours())}:
            {moment.duration(elapsedTime).minutes() < 10 && '0'}
            {moment.duration(elapsedTime).minutes()}:
            {moment.duration(elapsedTime).seconds() < 10 && '0'}
            {moment.duration(elapsedTime).seconds()}
          </h6>
        </div>
      </KTCard>
      {Boolean(rulesSection) && rulesSection}
      <KTCard className={`${cardClassName}`}>
        {!state.error && <div className=' flex-column justify-content-center  align-items-center pb-0 border-0'>
          <div className='d-flex flex-column w-100'>
            <div className='bg-f4f4f4 p-5 mb-7 rounded-3'>
              <div className='d-flex flex-column gap-4 '>
                <div className='d-flex flex-row'>
                  <h5 className='fs-3 me-4 text-gray-600'>Questions</h5>
                  <div
                    className='bg-gray-700  p-2 w-30px h-30px text-center text-white'
                    style={{ borderRadius: '6px' }}
                  >
                    {qusIndex}
                  </div>
                </div>

                <div>
                  {loading ? (
                    <div className='text-center'>
                      <Spinner animation='border' className='text-gray-600' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <>
                      <h6 className='w-100 fs-3'>
                        {question?.getLiveAgentQuestionsByPin?.questionDescription ?? 'question'}
                      </h6>
                      {(question?.getLiveAgentQuestionsByPin?.questionType === 'YESNO' ||
                        question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') && (
                          <div className='form-check form-check-script form-check-custom form-check-solid mt-7'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              checked={isYes}
                              id='YESNO'
                              onChange={() => {
                                if (
                                  question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION'
                                ) {
                                  setAnswer('')
                                  setIsYES(!isYes)
                                  setIsNo(false)
                                } else {
                                  setIsYES(!isYes)
                                  setIsNo(false)
                                }
                              }}
                            />
                            <label className='form-check-label' htmlFor='YES'>
                              Yes
                            </label>
                            <input
                              className='form-check-input ms-5'
                              type='checkbox'
                              id='DTMF'
                              checked={isNO}
                              onChange={() => {
                                if (!isNO && !question?.getLiveAgentQuestionsByPin?.continueCall) {
                                  areYouSurePrompt(
                                    'Are you sure?',
                                    () => {
                                      setAnswer('')
                                      setIsNo(!isNO)
                                      setIsYES(false)
                                      if (postionMsg === 'outbound') {
                                        setStartTpv(false)
                                        setShowGoBack(true)
                                      }
                                    },
                                    () => { },
                                    'Fail the Call',
                                    'Do not fail the call and go back',
                                    'You are about to mark this call as a failed enrollment. Are you sure you want to proceed?'
                                  )
                                } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') {
                                  setAnswer('')
                                  setIsNo(!isNO)
                                  setIsYES(false)
                                } else {
                                  setIsNo(!isNO)
                                  setIsYES(false)
                                }
                              }}

                            />
                            <label className='form-check-label' htmlFor='DTMF'>
                              No
                            </label>
                          </div>
                        )}
                      {(question?.getLiveAgentQuestionsByPin?.questionType === 'DTMF' ||
                        question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') && (
                          <div>
                            <label className={`d-flex align-items-center mb-2 mt-3`}>
                              <div className='fs-6 fw-semibold lh-23px'>Other</div>
                            </label>
                            <input
                              id='other'
                              type='text'
                              className='form-control form-control-lg form-control-solid bg-white'
                              name='other'
                              value={answer}
                              placeholder='Enter Answer'
                              onChange={(e) => {
                                if (
                                  question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION'
                                ) {
                                  setAnswer(e.target.value)
                                  setIsNo(false)
                                  setIsYES(false)
                                } else {
                                  setAnswer(e.target.value)
                                }
                              }}
                            />
                          </div>
                        )}

                      {question?.getLiveAgentQuestionsByPin?.questionType === 'VOICE_RESPONSE' && (
                        <div>
                          <label className={`d-flex align-items-center mb-2 mt-3`}>
                            <div className='fs-6 fw-semibold lh-23px'>Type Response</div>
                          </label>
                          <input
                            id='other'
                            type='text'
                            className='form-control form-control-lg form-control-solid bg-white'
                            name='other'
                            value={answer}
                            placeholder='Enter Answer'
                            onChange={(e) => {
                              if (
                                question?.getLiveAgentQuestionsByPin?.questionType ===
                                'VOICE_RESPONSE'
                              ) {
                                setAnswer(e.target.value)
                                setIsNo(false)
                                setIsYES(false)
                              } else {
                                setAnswer(e.target.value)
                              }
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <button
              className='btn btn-primary mw-150px align-self-center'
              onClick={() => handleSubmit()}
            >
              Continue
            </button>
          </div>
        </div>}
      </KTCard>
    </>
  )
}
export default Questions
